import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {CoverImageSource} from '@aviary/store/common/common.types';
import {PathFor} from '@aviary/store/router/router.types';
import {Action} from '@ngrx/store';
import {ExpansionTogglePosition, ExpansionToggleStyle, PaginationStyle} from '@aviary/components/table/table.component.types';
import {ButtonAppConfig} from '@aviary/buttons/button.types';
import {DialogAppConfig} from '@aviary/dialogs/base-dialog/base-dialog.types';

////
//// This file defines injection tokens that each app needs to provide values for, so that Aviary can inject them as needed
//// and still remain independent of each app's individual configurations.
////
//// Each token defined here includes the probable provider each app will need to define.
////

// {provide: API_URL, useValue: environment.apiUrl}
export const API_URL: InjectionToken<string> = new InjectionToken<string>('API_URL');

// {provide: BUTTON_APP_CONFIG, useValue: {...}}
export const BUTTON_APP_CONFIG: InjectionToken<ButtonAppConfig> = new InjectionToken<ButtonAppConfig>('BUTTON_APP_CONFIG');

// {provide: COVER_IMAGE_SOURCE, useFactory: () => select(OrganizationSelectors.Auth.coverImageSource)}
export const COVER_IMAGE_SOURCE: InjectionToken<Observable<CoverImageSource>> = new InjectionToken<Observable<CoverImageSource>>('COVER_IMAGE_SOURCE');

// {provide: DIALOG_APP_CONFIG, useValue: {...}}
export const DIALOG_APP_CONFIG: InjectionToken<DialogAppConfig> = new InjectionToken<DialogAppConfig>('DIALOG_APP_CONFIG');

// {provide: FALLBACK_COVER_IMAGE_URL, useValue: '/assets/fallback-cover-image.png'}
export const FALLBACK_COVER_IMAGE_URL: InjectionToken<string> = new InjectionToken<string>('FALLBACK_COVER_IMAGE_URL');

// { provide: ROUTER_PATH_FOR, useValue: PATH_FOR }
export const ROUTER_PATH_FOR: InjectionToken<PathFor> = new InjectionToken<PathFor>('PATH_FOR');

// {provide: LOGOUT_ACTION, useValue: UsersActions.logoutUser()},
export const LOGOUT_ACTION: InjectionToken<Action> = new InjectionToken<Action>('LOGOUT_ACTION');

// {provide: PAGINATION_STYLE, useValue: 'PAGE_NUMBERS'},
export const PAGINATION_STYLE: InjectionToken<PaginationStyle> = new InjectionToken<PaginationStyle>('PAGINATION_STYLE');

// {provide: TABLE_EXPANSION_TOGGLE_STYLE, useValue: 'ROTATING_CHEVRON'},
export const TABLE_EXPANSION_TOGGLE_STYLE: InjectionToken<ExpansionToggleStyle> = new InjectionToken<ExpansionToggleStyle>('TABLE_EXPANSION_TOGGLE_STYLE');

// {provide: TABLE_EXPANSION_TOGGLE_POSITION, useValue: 'START'},
export const TABLE_EXPANSION_TOGGLE_POSITION: InjectionToken<ExpansionTogglePosition> =
  new InjectionToken<ExpansionTogglePosition>('TABLE_EXPANSION_TOGGLE_POSITION');

// {provide: TABLE_SHOW_ACTIONS_HEADER_TEXT, useValue: true},
export const TABLE_SHOW_ACTIONS_HEADER_TEXT: InjectionToken<boolean> = new InjectionToken<boolean>('TABLE_SHOW_ACTIONS_HEADER_TEXT');
